module.exports = __webpack_public_path__ + "bq.svg?c038a38114772bfc160299d59aa68ee8";